import { useEffect } from 'react'
import { useNavigate, useLocation, Link, Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/dashboard/Sidebar'
import { useAuth } from '@/lib/hooks/useAuth'

function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="glass-card p-8 flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-accent/30 border-t-accent rounded-full animate-spin" />
        <p className="text-text-secondary text-sm">Chargement…</p>
      </div>
    </div>
  )
}

const MISSION_DETAIL_RE = /^\/missions\/[^/]+$/

export default function DashboardLayout() {
  const { user, loading, logout } = useAuth('COMPANY')
  const navigate = useNavigate()
  const pathname = useLocation().pathname

  const isCF = user?.companyType === 'TRAINING_CENTER'
  const allowedForCF = MISSION_DETAIL_RE.test(pathname)

  useEffect(() => {
    if (!loading && isCF && !allowedForCF) {
      navigate('/cf-dashboard', { replace: true })
    }
  }, [loading, isCF, allowedForCF, navigate])

  if (loading) return <Spinner />
  if (!user) return null
  if (isCF && !allowedForCF) return null

  // CF viewing a mission detail — minimal shell without company sidebar
  if (isCF) {
    return (
      <div className="min-h-screen p-8">
        <div className="max-w-3xl mx-auto w-full">
          <Link
            to="/cf-formations"
            className="inline-flex items-center gap-2 mb-6 text-sm text-text-secondary hover:text-accent transition-colors"
          >
            ← Retour aux demandes de formation
          </Link>
          <Outlet />
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex">
      <Sidebar user={user} onLogout={logout} />
      <div className="flex-1 ml-60 min-h-screen flex flex-col">
        <main className="flex-1 p-8">
          <div className="max-w-3xl mx-auto w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
